'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from 'next/image';
import Link from '@eliadmin/core/src/components/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface LogoProps {
  priority?: boolean;
  src?: string;
  alt?: string;
  generalLayout: GeneralLayout['data'];
  className: {
    link?: string;
    image: string;
  };
}

export function Logo({ src, alt, generalLayout, className, priority = false }: LogoProps) {
  return (
    <Link
      prefetch={false}
      href={ROUTES.HOME()}
      className={cn('cursor-pointer transition-all ease-in-out hover:opacity-75', className?.link)}
    >
      <Image
        src={src || generalLayout?.header?.logo?.url || '/images/placeholder.png'}
        alt={
          typeof alt === 'string'
            ? alt
            : resolveImageAlt(undefined, (generalLayout?.site_name?.trim() || '')) ||
              resolveImageAlt(src ? undefined : generalLayout?.header?.logo)
        }
        width={0}
        height={0}
        className={cn('w-auto shrink-0 object-contain object-center', className?.image)}
        sizes="(min-width: 1024px) 212px, (min-width: 640px) 185px, 159px"
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : undefined}
      />
    </Link>
  );
}
